import { motion, AnimatePresence } from 'motion/react';
import IconArrowDown from './IconArrowDown';

const variants = {
    closed: {
        backgroundColor: '#09172b',
        transition: {
            duration: 0.3,
        },
    },
    open: {
        backgroundColor: '#172850',
        transition: {
            duration: 0.3,
        },
    },
};

const AccordionItem = ({ item, isOpen, onToggle }) => {
  return (
    <motion.div className={`
    text-white min-h-[9.125rem]
    flex items-center justify-between pl-[3rem] pr-[2rem] py-[2rem]
    rounded-2xl
    border-[0.25rem] border-[#172850]
    relative
    ${isOpen ? 'pointer-events-none' : ''}
    `}
        variants={variants}
        animate={isOpen ? 'open' : 'closed' }
        onClick={onToggle}
      >
        <div className='flex-1 py-[2rem]'>
            <h3 className="font-extralight text-[2rem] leading-[2.5rem]">
            {item.title}
            </h3>
            {/* Contenido expandible (subtítulo y texto) */}
            <AnimatePresence>
                {isOpen && (
                <motion.div
                    key="content"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                >
                    <div className="mt-[1rem] font-light text-[1.125rem] leading-none uppercase">
                    Scan QR code to learn more
                    </div>
                </motion.div>
                )}
            </AnimatePresence>
        </div>
        
        <div className='w-[8.875rem]'>
        <AnimatePresence mode="wait">
            {isOpen && (
            <motion.img
                key="qr"
                src={`${process.env.PUBLIC_URL}/qr/${item.qr}`}
                alt="QR Code"
                className="h-[8.875rem] w-[8.875rem] object-contain"
                initial={{ height:0, opacity: 0 }}
                animate={{ height: "8.875rem", opacity: 1 }}
                exit={{ height:0, opacity: 0 }}
                transition={{ duration: 0.3 }}
            />
            )}
        </AnimatePresence>
        </div>
        
        <AnimatePresence mode="wait">
        {!isOpen && (
            <motion.div
                key="arrow"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}
                className='absolute right-[4.25rem] top-1/2 -translate-y-1/2'
            >
            <IconArrowDown className='w-[2rem] h-[1rem]' />
            </motion.div>
        )}
        </AnimatePresence>
    
    </motion.div>
  );
};

export default AccordionItem;
